import { render } from "./PacKage.vue?vue&type=template&id=18747f02"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/PacKage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18747f02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18747f02', __exports__)) {
    api.reload('18747f02', __exports__)
  }
  
  module.hot.accept("./PacKage.vue?vue&type=template&id=18747f02", () => {
    api.rerender('18747f02', render)
  })

}


export default __exports__